import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Globe } from 'lucide-react';
import { Button } from './ui/Button';
import { CountdownTimer } from './ui/CountdownTimer';
import { buildCheckoutUrl } from '../utils/checkout';
export function SpecialOffer() {
  return <section id="offer" className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-203" data-mp="u1getkhh4lrs">
      <div className="absolute inset-0 bg-stadium-glow opacity-80 pointer-events-none" data-id="element-204" data-mp="tzdh0ea2xoci"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-205" data-mp="f6jx8gnrym21">
        <div className="max-w-4xl mx-auto" data-id="element-206" data-mp="k4brhhbw6k9e">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-207" data-mp="k163y6iwvqfs">
            <div className="inline-block bg-red-600 text-white font-oswald uppercase tracking-widest px-4 py-1 rounded-full text-sm mb-6 animate-pulse" data-id="element-208" data-mp="25gliaqpfiocg">
              Launch Offer
            </div>
            <h2 className="font-anton text-5xl md:text-6xl text-white uppercase tracking-wide mb-4" data-id="element-209" data-mp="2puggnzy4psvw">
              SPECIAL OFFER
            </h2>
            <h3 className="font-oswald text-2xl md:text-3xl text-gold-500 uppercase tracking-widest" data-id="element-210" data-mp="33l3gxwjjfqu3">
              THE COMPLETE 6-VOLUME SYSTEM
            </h3>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-navy-950 border-2 border-gold-500/50 rounded-2xl p-6 md:p-12 shadow-[0_0_50px_rgba(242,193,78,0.15)] relative" data-id="element-211" data-mp="2axz6hc1oekax">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-navy-950 border-2 border-gold-500/50 px-6 py-2 rounded-full" data-id="element-212" data-mp="3biq0et6ang">
              <span className="font-anton text-xl text-gold-500 tracking-wider" data-id="element-213" data-mp="370uhset1np2">
                72% OFF
              </span>
            </div>

            <div className="mb-10" data-id="element-214" data-mp="76i2ashpewxe">
              <img src="https://cdn.magicpatterns.com/uploads/fFAosTkQ8VwVNFGiru2e79/ChatGPT_Image_11_jun_2026,_14_23_42.webp" alt="System 365 Mockup" width={1536} height={1024} loading="lazy" decoding="async" style={{
              aspectRatio: '1536 / 1024'
            }} className="block w-full max-w-2xl mx-auto h-auto rounded-xl shadow-2xl" data-id="element-215" data-mp="c762a3nwuo3r" />
            </div>

            <div className="text-center mb-10" data-id="element-216" data-mp="3udaoa9hkqgtt">
              <div className="text-gray-400 font-oswald text-xl line-through mb-2" data-id="element-217" data-mp="3ue3kwhmtjpy8">
                Regular Price: USD 97
              </div>
              <div className="text-gold-500 font-oswald text-2xl uppercase tracking-widest mb-2" data-id="element-218" data-mp="31w83z1fhjgz1">
                Today Only:
              </div>
              <div className="font-anton text-7xl md:text-8xl text-white tracking-wider mb-4 drop-shadow-lg" data-id="element-219" data-mp="2ucgnthmoxlnt">
                USD 19
              </div>
              <p className="inline-flex items-center gap-2 text-gold-400 text-sm font-medium" data-id="element-220" data-mp="2kej0qxgkhuws">
                <Globe className="w-4 h-4" data-id="element-221" data-mp="2ffy9von7gnl0" />
                Pay securely in your local currency.
              </p>
            </div>

            <div className="bg-navy-900 border border-navy-700 rounded-xl p-6 mb-10" data-id="element-222" data-mp="2bf5yaoqv26lk">
              <div className="text-center mb-6" data-id="element-223" data-mp="26n4emhrd5dli">
                <span className="text-red-400 font-bold flex items-center justify-center gap-2" data-id="element-224" data-mp="26lb8r4okqxek">
                  <span className="animate-pulse" data-id="element-225" data-mp="21m714ihat7qc">🔥</span>
                  Last Chance! This price increases when the countdown expires.
                </span>
              </div>
              <CountdownTimer data-id="element-226" data-mp="1rplwhy96xyn1" />
            </div>

            <div className="flex flex-col items-center gap-6" data-id="element-227" data-mp="1nos873ru6htm">
              <Button size="xl" fullWidth className="max-w-2xl" onClick={() => {
              ;
              (window as any).fbq?.('track', 'InitiateCheckout', {
                value: 19,
                currency: 'USD'
              });
              window.location.href = buildCheckoutUrl();
            }} data-id="element-228" data-mp="1nqmryerdg3w4">
                YES, I WANT THE COMPLETE SYSTEM (USD 19)
              </Button>

              <div className="flex flex-col items-center gap-3" data-id="element-229" data-mp="1tn3pb4cr8ku7">
                <div className="flex items-center gap-1" data-id="element-230" data-mp="1yo1fo47x4l6s">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-231" data-mp="1kp1sz23yugd9" data-mpi={i} />)}
                  <span className="ml-2 font-oswald text-lg text-gray-200" data-id="element-232" data-mp="3f2ati4ejarjd">
                    4.9/5 — Verified Reviews
                  </span>
                </div>

                <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-233" data-mp="3j1ijw5agf1xm">
                  <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-234" data-mp="17gj212klgq1v" />
                  <span data-id="element-235" data-mp="13fpdq838p98g">7-Day Money Back Guarantee — Zero Risk</span>
                </div>

                <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-236" data-mp="1h6cc1z538x40">
                  <Globe className="w-4 h-4 text-gold-500" data-id="element-237" data-mp="1cf44l8nbjlth" />
                  <span data-id="element-238" data-mp="1cdjafk4x24w5">Pay In Your Local Currency</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}